import React from 'react';
import { CtaButton } from './CtaButton';
type Props = {
  headline: string;
  label?: string;
  location: string;
  tone?: 'light' | 'dark';
};

/**
 * "Transformational" CTA block placed at the end of every section: names the
 * shift the reader wants, then offers the button that gets them there.
 */
export function TransformCta({
  headline,
  label = 'Quiero el Sistema de Diagnóstico Facial',
  location,
  tone = 'light'
}: Props) {
  const isDark = tone === 'dark';
  return <div className={`mx-auto mt-10 w-full max-w-md rounded-3xl border px-4 py-5 sm:px-6 ${isDark ? 'border-white/15 bg-white/5' : 'border-navy-100 bg-white shadow-card'}`} data-id="element-315" data-mp="631v7o5ar561">
      <p className={`mb-4 text-center font-display text-[17px] font-semibold leading-snug sm:text-xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-316" data-mp="f3qasnac9dl1">
        {headline}
      </p>
      <CtaButton label={label} location={location} size="md" data-id="element-317" data-mp="1qj57dpymy3fm" />
      <p className={`mt-3 text-center text-[11px] font-medium ${isDark ? 'text-white/60' : 'text-navy-500'}`} data-id="element-318" data-mp="1qkq3vl4ifwg4">
        Acceso inmediato · Pago único de $12.99 USD · Garantía de 7 días
      </p>
    </div>;
}